import jwt_decode from "jwt-decode";

export const isAdminLoggedIn = () => {
   const accessToken = localStorage.getItem('accessToken');
   const userType = accessToken && jwt_decode(accessToken && accessToken).userType
   if (accessToken && userType === "A") {
      return true;
   }
   return false;
}

export const isUserLoggedIn = () => {
   const accessToken = localStorage.getItem('accessToken');
   const userType = accessToken && jwt_decode(accessToken && accessToken).userType
   if (accessToken && userType === "U") {
      return true;
   }
   return false;
}